import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { ClaimListScreen } from 'screens/claim';

export default withPermissions(ClaimListScreen, [GroupSecurity.ClaimRead]);
